import { gql } from '@apollo/client';

export interface DspScanInfoDetailType {
  trackingNumber: string;
  areaName: string;
  assignedDriverId: number
  assignedDriver: string | null;
  areaId: number,
  taskDate: string;
}

export interface GetDspScanInfoDetailResponse {
  getDspScanInfoDetail: {
    parcelList: DspScanInfoDetailType[];
    successScanParcelCount: number | null;
    expectedParcels: number | null;
    scannedRouteCount: number | null;
    totalRouteCount: number;
    dspScanDeliveryTaskOrderIdList: number[];
    driverIdList: number[] | null;
  };
}

export const GET_DSP_SCAN_INFO_DETAIL = gql`
  query GetDspScanInfoDetail($warehouseId: Long) {
    getDspScanInfoDetail(warehouseId: $warehouseId) {
      parcelList {
        trackingNumber
        areaName
        assignedDriverId
        assignedDriver
        areaId
        taskDate
      }
      successScanParcelCount
      expectedParcels
      scannedRouteCount
      totalRouteCount
      dspScanDeliveryTaskOrderIdList
      driverIdList
    }
  }
`;